import { postRequest } from '@/utils/request';
import { getHost } from '@/utils/utils';

// 获取分享链接
export async function getInviteLink(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v1/user/genInvite`, data);
}

// 我的推广数据-三期
export async function getInviteInfoDetail(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v1/user/inviteList`, data);
}

// 邀请好友二期获取邀请进度
export async function getInviteSchedule(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/device/list/historyOnline`, data);
}

// 跑马灯/邀请排行榜
export async function getInviteRankList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/user/invite/scrollLight`, data);
}

// 接口文档：http://wiki.onething.net/pages/viewpage.action?pageId=160924680
// 获取邀请好友详情 -- 分布式
export async function queryInviteOverview(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/invite/detail`, data);
}

// 奖励详情 -- 分布式奖励
export async function queryInviteRewardDetail(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/invite/reward/detail`, data);
}

// 邀请好友列表 -- 分布式奖励
export async function queryInviteListByType(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/invite/friendList`, data);
}

// 好友进度详情 -- 分布式奖励
export async function queryInviteMissionStatusByUser(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/invite/friend/task/detail`, data);
}

// 被邀请人进度页 -- 分布式奖励
export async function queryInviteeMissionInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/invite/newuser/taskList`, data);
}

// x86邀请好友
export async function queryX86InviteSummary(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/summary`, data);
}

// x86邀请好友提成比例
export async function queryX86InviteRewardConfig(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/commission/rate`, data, { hideLoading: false });
}

// x86邀请好友排行榜
export async function queryX86InviteRank(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/rank/list`, data, { hideLoading: false });
}

// x86邀请好友分享信息
export async function getX86InviteShareInfo(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/user/genInvite`, data, { hideLoading: false });
}

// 查询代理收入明细
export async function getProxyRewardList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/rewardlog/list`, data, { hideLoading: false });
}

// 获取代理朋友列表信息-代理明细
export async function getProxyFriendList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/detail/getfriendlist`, data, {
    hideLoading: false,
  });
}

// 获取代理朋友设备明细
export async function getProxyDeviceList(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/device/list`, data, {
    hideLoading: false,
  });
}

// 设置好友用户备注名字
export async function setFriendRemard(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/x86/proxy/detail/setfriendname`, data, {
    hideLoading: false,
  });
}
// // TODOx86邀请记录页
// export async function getInviteRecordList(data) {
//   return postRequest(`${host}/v3/user/inviteRecordList`, data, { hideLoading: false });
// }
